<template>
  <v-dialog :value="dialog" max-width="400" @click:outside="closePopup">
    <v-card>
      <v-card-actions class="pb-0 mb-n4">
        <v-spacer></v-spacer>

        <v-btn @click="closePopup" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>

      <v-card-text class="px-8  text-center">
        <p class="font font--p-sm mb-8 mt-2">
          Укажите номер своего мобильного телефона. Последующий вход в Личный кабинет будет осуществляться по нему
        </p>
        <v-form ref="form" v-model="valid">
          <v-text-field
            label="Номер телефона"
            height="44px"
            dense
            placeholder=" "
            outlined
            autofocus
            required
            :rules="[rules.required('Введите номер телефона'), rules.isPhone]"
            style="text-align: center"
            v-mask="'+7(9##) ###-##-##'"
            v-model="transferPhone"
            name="phone"
            type="text"
          ></v-text-field>

          <v-text-field
            height="44px"
            dense
            label="Текущий пароль"
            placeholder=" "
            :rules="[rules.required('Введите текущий пароль')]"
            outlined
            v-model="currentPass"
            prepend-inner-icon="mdi-lock-outline"
            :type="show ? 'text' : 'password'"
          >
            <template v-slot:append>
              <v-icon @click="show = !show" tabindex="-1" v-if="show">mdi-eye</v-icon>
              <v-icon @click="show = !show" tabindex="-1" v-else>mdi-eye-off</v-icon>
            </template>
          </v-text-field>
        </v-form>

        <v-btn :disabled="!valid" class="mb-10" @click="sendPhone" color="primary" large>Подтвердить</v-btn>

        <p style="line-height: 17px;" class="tooltip__base font font--label-light font--color_light">
          Возникли проблемы? Свяжитесь с нами по телефону:<br />
          <span v-show="isCopied" class="tooltip">Скопировано</span>
          <a href="#"  @click.prevent="copyPhone">8 (800) 444-10-85</a>

        </p>

      </v-card-text>

    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { mask } from "vue-the-mask";


export default {
  directives: { mask },
  data() {
    return {
      isCopied: false,
      valid: false,
      show: false,
      rules: {
        required: (msg) => (v) => !!v || msg,
        isPhone: (v) => v.replace(/\D/g, "").length === 11 || "Введите номер телефона"
      }
    }
  },
  methods: {
    ...mapMutations("user_transfer", ["setPhone", "setPhoneForm", "setPass"]),
    ...mapActions("user_transfer", ["transferUser"]),
    hideCopied() {
      this.isCopied = false;
    },
    setCopied() {
      this.isCopied = true;
      setTimeout(this.hideCopied, 2000)
    },
    copyPhone() {
      const phone = "8(800)444-10-85";
      if (navigator.clipboard != undefined) {
        //Chrome
        navigator.clipboard.writeText(phone).then(
          this.setCopied,
          function (err) {
            console.error("Не удолось скопировать ссылку ", err);
          }
        );
      } else if (window.clipboardData) {
        // Internet Explorer
        window.clipboardData.setData("Text", phone);
        this.setCopied();
      }

    },
    closePopup() {
      this.$refs.form.resetValidation();
      this.setPhoneForm(false);
    },
    sendPhone() {
      this.transferUser();
    },
  },
  computed: {
    ...mapState("user_transfer", ["phone", "pass"]),
    ...mapGetters("user_transfer", ["show_phone"]),
    dialog: {
      get() {
        return this.show_phone
      },
      set(v) {
        this.setPhoneForm(v)
      }
    },
    transferPhone: {
      get() {
        return this.phone;
      },
      set(value) {
        this.setPhone(value);
      }
    },
    currentPass: {
      get() {
        return this.pass;
      },
      set(v) {
        this.setPass(v);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  color: white;
  position: absolute;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  top: -50%;
  &__base {
    position: relative;
  }
}
</style>
